export default __webpack_public_path__ + "static/marketIntegration2-505beb23603dc5a878f28e0aa6082e1a.jpg";